import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { HandCoins } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { useAuthedApi, errMsg, formatINR } from "../lib/api";

export const offerBounds = (car) => [car.offer_min || Math.round(car.price * 0.7), car.offer_max || car.price];

export default function OfferDialog({ car, open, onOpenChange }) {
  const api = useAuthedApi();
  const navigate = useNavigate();
  const [lo, hi] = offerBounds(car);
  const [amount, setAmount] = useState("");
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const n = Number(amount);
  const err = !amount ? "" : n < lo || n > hi ? `Offers must be between ${formatINR(lo)} and ${formatINR(hi)}` : "";
  const valid = amount && !err;

  const submit = async (e) => {
    e.preventDefault();
    if (!valid) return;
    setBusy(true);
    try {
      const r = await api("post", `/listings/${car.id}/offers`, { amount: n, message });
      toast.success(`Your offer of ${formatINR(n)} was sent. Continue the chat with the seller.`);
      onOpenChange(false);
      navigate(`/chat/${r.thread_id}`);
    } catch (e2) { toast.error(errMsg(e2)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#111319] border-[#D4AF37]/30 text-white sm:max-w-md" data-testid="offer-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl gold-text flex items-center gap-2"><HandCoins className="w-6 h-6 text-[#D4AF37]" />Make an Offer</DialogTitle>
          <DialogDescription className="text-gray-400">{car.year} {car.brand} {car.model} · asking {formatINR(car.price)}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="lux-label">Your offer (₹)</label>
            <input className={`lux-input !text-lg ${err ? "!border-red-500/70" : ""}`} type="number" inputMode="numeric" autoFocus value={amount} onChange={(e) => setAmount(e.target.value)} placeholder={`${lo}`} data-testid="offer-amount-input" />
            <div className="flex justify-between text-[11px] mt-1.5">
              <span className={err ? "text-red-400" : "text-gray-400"} data-testid={err ? "offer-amount-error" : "offer-amount-hint"}>{err || `Allowed: ${formatINR(lo)} – ${formatINR(hi)}`}</span>
              {valid && <span className="text-[#E5C158]">{formatINR(n)}</span>}
            </div>
          </div>
          <div><label className="lux-label">Note to seller (optional)</label><textarea className="lux-textarea" rows={3} maxLength={1000} value={message} onChange={(e) => setMessage(e.target.value)} data-testid="offer-message-input" /></div>
          <button className="btn-gold w-full disabled:opacity-40 disabled:cursor-not-allowed" disabled={!valid || busy} data-testid="offer-submit-btn">{busy ? "Sending..." : "Send offer & open chat"}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
